import React from "react";
import { Helmet } from "react-helmet";

declare global {
  interface Window {
    smartsupp?: any;
  }
}

const Smartsupp: React.FC = () => {
  return (
    <Helmet>
      <script>
        {`
  var _smartsupp = _smartsupp || {};
  _smartsupp.key = '4d9a69848dff30e75c0af718427725556d90329f';
  (function(d) {
    var s, c, o = smartsupp = function() {
      o._.push(arguments)
    };
    o._ = [];
    s = d.getElementsByTagName('script')[0];
    c = d.createElement('script');
    c.type = 'text/javascript';
    c.charset = 'utf-8';
    c.async = true;
    c.src = '//www.smartsuppchat.com/loader.js?';
    s.parentNode.insertBefore(c, s);
  })(document);
`}
      </script>
    </Helmet>
  ); // Return an empty component as Smartsupp will load externally
};

export default Smartsupp;
